import React from "react";

import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/plugins/link";
import "tinymce/plugins/paste";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

import { Editor } from "@tinymce/tinymce-react";
import tinyMCEConfig from "../../constants/TinyMCEConfig";

const { useState } = React;

const parentClassname = "react-form";

const ReactFormFieldRTE = props => {
    const [content, setContent] = useState(props.defaultValue || props.value);
    let setContentTimeout;
    const customMCEConfig = { ...tinyMCEConfig };
    // const maxRegex = /max-(\d+)/i;
    // const maxMatch = props.className && props.className.match(maxRegex);
    const componentClassname = parentClassname
        ? `${parentClassname}__field`
        : "field";

    const labelPlaceholderClassname = props.labelplaceholder
        ? `${componentClassname}__label--labelplaceholder`
        : "";

    const hasErrors =
        !props.hideErrors &&
        props.errors &&
        props.errors.length &&
        props.showErrors;

    const handleEditorChange = content => {
        clearTimeout(setContentTimeout);
        setContent(content);
        if (props.onChange) {
            setContentTimeout = setTimeout(() => {
                props.onChange({
                    target: {
                        value: content,
                        name: props.name,
                    },
                });
            }, 300);
        }
    };

    if (props.height) {
        customMCEConfig.height = props.height;
    }

    return (
        <div
            className={`${componentClassname} 
				${componentClassname}--${props.type}
				${componentClassname}--rte 
				${props.classes.inheritedClasses} 
				${props.classes.isDisabled} 
				${props.classes.isIncomplete} 
				${props.classes.isFocused} 
				${props.classes.hasValue}
				${props.classes.isValid}
                ${props.classes.isInvalid}
                ${props.checked ? "is-checked" : ""}
			`}
        >
            <label htmlFor={props.accessibilityIds.input}>
                {/*label*/}
                {props.label ? (
                    <div
                        className={`${componentClassname}__label  ${labelPlaceholderClassname} ${parentClassname}__label-title`}
                    >
                        <div
                            className={`${componentClassname}__label__inner`}
                            id={props.accessibilityIds.label}
                        >
                            {props.label}
                            {props.required ? null : !props.hideOptional ? (
                                <span
                                    className={`${componentClassname}__label__optional-label`}
                                ></span>
                            ) : null}
                        </div>
                    </div>
                ) : null}
                {/*info*/}
                {props.info ? (
                    <div
                        className={`${componentClassname}__info ${parentClassname}__label-description`}
                        id={props.accessibilityIds.description}
                    >
                        {props.info}
                    </div>
                ) : null}

                {/*input element*/}
                <Editor
                    initialValue={props.defaultValue}
                    init={customMCEConfig}
                    value={content}
                    onEditorChange={(value, editor) =>
                        handleEditorChange(value)
                    }
                    disabled={props.disabled}
                />
                {/* <RichTextEditor
                        className={`${componentClassname}__rte`}
                        value={content}
                        onChange={handleEditorChange}
                        ref={input => {
                            props.inputElement.ref.current = _.get(
                                input,
                                "refs.editor.editor",
                                null
                            );
                        }}
                        onFocus={() => {
                            props.onFocus &&
                                props.onFocus({
                                    target: {
                                        value: content.toString("html"),
                                        name: props.name,
                                    },
                                });
                        }}
                        onBlur={() => {
                            props.onBlur &&
                                props.onBlur({
                                    target: {
                                        value: content.toString("html"),
                                        name: props.name,
                                    },
                                });
                        }}
                    /> */}

                {/* {maxMatch && (
                    <div className={`${componentClassname}__counter`}>
                        {props.inputElement.props.value.length} / {maxMatch[1]}
                    </div>
                )} */}
            </label>

            {/*errors*/}
            {hasErrors ? (
                <div className={`${componentClassname}__errors`}>
                    <div
                        className={`${componentClassname}__errors__item`}
                        id={props.accessibilityIds.error}
                    >
                        {props.errors[0]}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default ReactFormFieldRTE;
